<div class="questionnaire-detail">
  @for (question of questionnaire.questions; track question; let i = $index) {
    <div class="question-answer" data-cy="questionnaire-item">
      <div class="label-title position-question" data-cy="questionnaire-num">設問{{ i + 1 }}</div>
      <div class="block-element">
        @if (!isReadMore) {
          <p class="question-content" data-cy="questionnaire-content">{{ question.text }}</p>
        } @else {
          <app-read-more [content]="question.text" [collapsedLength]="149"></app-read-more>
        }
        @if (question.src) {
          <img class="question-image" data-cy="questionnaire-image" src="{{ question.src }}" />
        }
        <p class="label-title answer-info">回答</p>
        @for (answer of listAnswers[i]; track answer) {
          @for (answerOption of answer['answer_options']; track answerOption) {
            @if (answerOption.text) {
              <div>
                @if (!isReadMore) {
                  <p class="preserve-line-break" data-cy="questionnaire-answer">
                    {{ answerOption.text }}
                  </p>
                } @else {
                  <app-read-more [content]="answerOption.text" [collapsedLength]="149"></app-read-more>
                }
              </div>
            }
            @if (answerOption.src) {
              <img class="answer-image" data-cy="questionnaire-answer-image" src="{{ answerOption.src }}" />
            }
          }
          <div class="block-attached">
            <div class="row">
              @if (answer.attached) {
                <div class="image-attached" (window:resize)="resize()" #upload_div>
                  <div class="attach" (click)="onFileClick(answer)">
                    @if (isShowThumbnail(answer.attached_file_name)) {
                      <div class="attach-file">
                        <img [src]="answer.attached" />
                      </div>
                    } @else {
                      <div class="file-format"><i [ngClass]="answer.attached_file_name | fileIconClass"></i></div>
                    }
                    @if (showDownloadIcon(answer)) {
                      <a class="action-file">
                        <i class="fa fa-download"></i>
                      </a>
                    }
                  </div>
                  <p class="file-name" (click)="onFileClick(answer)">{{ answer.attached_file_name }}</p>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  @if (!!categoryName) {
    <div class="category-text">
      {{ categoryName }}
    </div>
  }

  <app-questionnaire-file-preview></app-questionnaire-file-preview>
</div>
